<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <degrees-clear></degrees-clear>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DegreesClear from './degrees/DegreesClear';

    export default {

        components: {
            DegreesClear
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.degrees'),
                        route: '/astral/ui/training/degrees'
                    },
                    {
                        name: this.$t('common.outdated'),
                    },
                ]
            }
        },
    }
</script>
